//FRAMEWORK
import { useMediaQuery, useTheme } from "@material-ui/core"
import Container from "@material-ui/core/Container"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"
import Loading from "../Componentes/Loading"
import GaleriaConteudo from "./GaleriaConteudo"

export default function Galeria() {
    const configs = useAppStore(s => s.configuracoes)
    const loading = useLoadingStore(s => s.loading)

    const estabelecimento = configs?.user?.parametros?.estabelecimento

    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))

    return (
        <Container className="container-buscando">
            <Loading loading={loading} />

            <div
                style={{
                    paddingTop: mobile ? "72px" : "4.8rem",
                    marginLeft: mobile ? "" : "var(--drawer-width, 80px)",
                    transition: "margin-left 0.2s ease",
                }}
            >
                {estabelecimento?.id ? (
                    <GaleriaConteudo estabelecimento={estabelecimento} />
                ) : null}
            </div>
        </Container>
    )
}
